import t from 'tcomb';

const Currency = t.enums.of('EUR CAD GBP USD ZAR BRL'.split(' '));

module.exports = Currency;




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Currency.js
 **/